import axios from "axios"
import { getProviderPhotoThumbnailEndpoint } from "../Provider/loader"

export const getProviderPhotoThumbnail = async (providerId: string) => {
  const url: string = getProviderPhotoThumbnailEndpoint(providerId)
  return await axios.get(url, { responseType: "blob" })
}
